import React from 'react';
import { Box, Typography } from '@mui/material';
import { PhoneAndroid } from '@mui/icons-material';

interface DeviceErrorPageProps {
  onEnableDevMode?: () => void;
}

export const DeviceErrorPage: React.FC<DeviceErrorPageProps> = ({ onEnableDevMode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <PhoneAndroid sx={{ fontSize: 80, color: '#666', mb: 2 }} />
      <Typography variant="h5" component="h1" gutterBottom>
        This app can be used with mobile devices only
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Please access this application from a mobile device or contact your administrator.
      </Typography>
      {/* {onEnableDevMode && (
        <Button
          variant="outlined"
          onClick={onEnableDevMode}
          sx={{ mt: 2 }}
        >
          Enable Developer Mode
        </Button>
      )} */}
    </Box>
  );
};

